export default {
  defaultStyle: {
    margin: '0',
    border: 'none',
    padding: '0',
    background: 'none',
    WebkitBoxSizing: 'border-box',
    MozBoxSizing: 'border-box',
    boxSizing: 'border-box',
    '&:focus': {
      outline: 'none'
    },
    cursor: 'pointer',
    '& > span':{
      pointerEvents: 'none',
    }
  },
  hide: {
    display: 'none'
  },
  disabled: {
    background: '#f1f1f1',
    color: '#000'
  },
  toggleMainButton: {
    border: data => '1px solid ' + data.mainColor,
    width: '100%',
    backgroundColor: data => data.mainColor,
    color: '#fff',
    textAlign: 'center',
    textDecoration: 'none',
    padding: '15px 0',
    '&:hover': {
      WebkitTransition: '0.3s',
      OTransition: '0.3s',
      MsTransition: '0.3s',
      MozTransition: '0.3s',
      color: data => data.mainColor,
      backgroundColor: 'transparent'
    },
    '&$disabled': {
      background: '#b2b2b2',
      borderColor: '#b2b2b2',
      '&:hover': {
        background: '#b2b2b2 !important',
        borderColor: '#b2b2b2 !important',
        color:'#fff !important',
      }
    }
  },
  selected: {},
  toggleSecondButton: {
    background: data => data.secondColor,
    border: data => '1px solid ' + data.secondColor,
    color: '#fff',
    font: "16px 'Open Sans',sans-serif",
    height: '42px',
    width: '177px',
    display: 'inline-block',
    verticalAlign: 'middle',
    cursor: 'pointer',
    overflow: 'visible',
    boxSizing: 'border-box',
    '&:hover': {
      background: 'transparent',
      color: data => data.secondColor,
      WebkitTransition: '0.3s',
      OTransition: '0.3s',
      MsTransition: '0.3s',
      MozTransition: '0.3s',
      transition: '0.3s'
    },
    '&$selected': {
      background: '#fff',
      color: data => data.secondColor
    },
    '&$disabled': {
      background: '#bbb',
      border: '1px solid #bbb',
      color: '#fff',
      '&:hover': {
        background: '#bbb',
        border: '1px solid #bbb',
        color: '#fff'
      }
    },
    '& .notClickable': {
      pointerEvents: 'none',
    },
  },
  backButton: {
    width: '100%',
    height: '100%',
    '&:lang(ar)':{
      transform: 'rotate(180deg)',
    }
  },
  summary: {
    height: '50px',
    width: '200px',
    borderWidth: '2px',
    fontSize: '16px'
  },
  toggleMainButtonReverse: {
    border: data => '1px solid ' + data.mainColor,
    color: data => data.mainColor,
    boxSizing: 'content-box',
    textTransform: 'uppercase',
    cursor: 'pointer',
    textAlign: 'center',
    textDecoration: 'none',
    padding: '15px 0',
    width: '100%',
    '&:hover': {
      WebkitTransition: '0.3s',
      OTransition: '0.3s',
      MsTransition: '0.3s',
      MozTransition: '0.3s',
      color: '#fff',
      backgroundColor: data => data.mainColor,
      '& span': {
        color: '#fff'
      }
    }
  },
  buttonCalendarText: {
    textTransform: 'none',
  },
  acceptDuplicatedButton: {
    border: data => '1px solid ' + data.mainColor,
    color: '#00111b',
    boxSizing: 'content-box',
    textTransform: 'uppercase',
    cursor: 'pointer',
    textAlign: 'center',
    textDecorationColor: '#00111b',
    textDecoration: 'none',
    padding: '5px 0',
    width: '10%',
    '&:hover': {
      WebkitTransition: '0.3s',
      OTransition: '0.3s',
      MsTransition: '0.3s',
      MozTransition: '0.3s',
      color: '#fff',
      backgroundColor: 'white',
      '& span': {
        color: '#fff'
      }
    }
  },
  closeButton: {
    background: 'none',
    cursor: 'pointer',
    color: data => data.mainColor,
    border: '0',
    fontSize: '16px',
    position: 'absolute',
    top: '17px',
    right: '16px',
    height: '16px',
    width: '16px',
    marginTop: '-8px',
    zIndex: '1',
    '&:lang(ar)': {
      right: 'auto',
      left: '16px'
    }
  },
  searchOptionsFilterButton: {
    textTransform: 'none',
    color: '#fff',
    background: data => data.mainColor,
    font: "italic 16px 'Droid Serif'",
    float: 'right',
    padding: '10px 0',
    width: 'calc(44%)',
    maxWidth: '250px',
    '&:lang(ar)': {
      float: 'left'
    }
  },
  searchOptionsFilterButtonReverse: {
    textTransform: 'uppercase',
    color: data => data.mainColor,
    border: data => '1px solid ' + data.mainColor,
    height: '40px',
    font: "13px 'Roboto', sans-serif",
    padding: '0 15px',
    width: 'calc(35%)',
    maxWidth: '250px',
    boxSizing: 'border-box'
  },
  searchOptionsCalendar: {
    display: 'block',
    textAlign: 'center',
    height: '55px',
    width: '210px',
    position: 'relative',
    padding: '0 15px 0 45px',
    '&:lang(ar)': {
      paddingRight: '45px',
      paddingLeft: '15px'
    }
  },
  svgIcon: {
    position: 'absolute',
    top: '50%',
    left: '7px',
    width: '14px',
    height: '14px',
    fill: data => data.mainColor,
    marginTop: '-7px',
    '&:lang(ar)': {
      left: 'auto',
      right: '7px'
    }
  },
  summarySendAvail: {
    minWidth: '175px',
    width:'auto',
    padding: '10px',
    marginTop: '5px'
  },
  buttonStyleTimeout: {
    border: data => '1px solid ' + data.mainColor,
    backgroundColor: data => data.mainColor,
    color: '#fff',
    textAlign: 'center',
    textDecoration: 'none',
    padding: '0 15px',
    display: 'inline-block',
    verticalAlign: 'bottom',
    height: '40px',
    margin: '5px 0 0 7px',
    '&:hover': {
      WebkitTransition: '0.3s',
      OTransition: '0.3s',
      MsTransition: '0.3s',
      MozTransition: '0.3s',
      color: data => data.mainColor,
      backgroundColor: 'transparent'
    },
    '@media (min-width: 601px)': {
      height: '50px'
    },
    '&:lang(ar)': {
      marginRight: '7px',
      marginLeft: '0px'
    }
  },
  searchOptionsCalendarMobile: {
    textTransform: 'uppercase',
    color: data => data.mainColor,
    marginRight: '5px',
    paddingLeft:'25px',
    position:'relative',
    textAlign:'left',
    '&:lang(ar)': {
      marginRight: '0',
      marginLeft: '5px'
    }
  },
  searchOptionsHotelLink: {
    width: '100%',
    //height: '40px',
    position: 'relative',
    font: "13px 'Roboto',sans-serif",
    '&:before': {
      content: "''",
      position: 'absolute',
      left: '20%',
      right: '20%',
      background: 'transparent',
      bottom: '0',
      height: '3px',
      WebkitTransition: '0.3s',
      OTransition: '0.3s',
      transition: '0.3s'
    },
    '&:hover:before': {
      left: '0',
      right: '0',
      background: data => data.mainColor
    },
    '@media (min-width: 801px)': {
      height: '100%',
      padding: '0 10px',
      minHeight:'50px',
      '& span': {
        '& span': {
          '&:lang(ar)': {
            transform: 'rotate(180deg)'
          }
        }
      },
    },
    '&:lang(nl)': {
      '@media (min-width: 901px)': {
        paddingRight:'30px'
      }
    },
  },
  alertButton: {
    display: 'table-cell',
    verticalAlign: 'middle',
    border: 'solid 1px #d0021b',
    backgroundColor: '#fff',
    height: '35px',
    minWidth: '48px',
    textTransform: 'uppercase',
    margin: '0 10px 7px 0',
    cursor: 'pointer',
    '@media (min-width: 901px)': {
      height: '40px',
      marginBottom: '10px'
    },
    '&:hover': {
      background: '#d0021b',
      color: '#fff',
      transition: '.3s'
    }
  },
  tabListButton: {
    font: "13px 'Roboto', sans-serif",
    textTransform: 'uppercase',
    padding: '10px',
    minHeight: '42px',
    position: 'relative',
    width: '100%',
    '& span:first-of-type': {
      font: '18px Icons',
      position: 'relative',
      marginRight: '3px',
      '@media (min-width: 801px)': {
        fontSize: '24px'
      }
    },
    '& span': {
      verticalAlign: 'middle',
      '@media (min-width: 801px)': {
        fontSize: '16px'
      }
    }
  },
  mainColor: {
    color: data => data.mainColor
  },
  dateChagenButton:{
    width:'180px'
  },
};
